// file: CartBundleDetails.jsx
import React, { useEffect, useState } from "react";

import styles from "./cartBundleDetails.module.scss";
import CartBundleTile from "../../components/uiComponents/cartBundleTile/CartBundleTile";
import AddressTile from "../../components/uiComponents/addressTile/AddressTile";
import TimeStamp from "../../components/uiComponents/timeStamp/TimeStamp";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import ToggleSwitch from "../../components/customComponents/toggleSwitch/ToggleSwitch";
import { useDispatch } from "react-redux";

import {
  createShipment,
  getCalculationByCardBundleId,
  getPackageDetails,
  getShipment,
  updateOrderStatusByCartBundleId,
  updatePacakgeDetails,
} from "../../store/actions";
import { useNavigate } from "react-router-dom";
import Tracking from "../../components/uiComponents/tracking/Tracking";
import PackageDetails from "../../components/uiComponents/packageDetails/PackageDetails";
import PaymentSummary from "../../components/uiComponents/paymentSummary/PaymentSummary";

const initialState = {
  type: "",
  length: "",
  breadth: "",
  height: "",
  weight: "",
};

const CartBundleDetails = ({
  cartBundleId,
  user,
  shipment,
  packageDetails,
  calculation,
}) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const [packageData, setPackageData] = useState(initialState);

  console.log("cartBundleId", cartBundleId);
  const { id, Status, page } = location?.state;
  console.log("user", user);
  const handleChange = (value) => {
    setStatus(value);
    console.log("value", value);
    let statusId = null;
    switch (value) {
      case "placed":
        statusId = 0;
        break;
      case "packed":
        statusId = 1;
        break;
      case "shipped":
        statusId = 2;
        break;
      case "delivered":
        statusId = 3;
        break;
      default:
        statusId = null;
    }

    dispatch(
      updateOrderStatusByCartBundleId({
        id: id,
        status: statusId,
        callback: {
          success: (data) => {
            if (statusId === 1) {
              dispatch(
                createShipment({
                  cartBundleId: id,
                  addressId: cartBundleId?.address?.id,
                  callback: { success: () => navigate(-1) },
                })
              );
            } else {
              navigate(-1);
            }
          },
        },
      })
    );
  };
  console.log("id:", id);

  const showStatus = (value) => {
    let showval = "";
    switch (value) {
      case 0:
        showval = "placed";
        break;
      case 1:
        showval = "packed";
        break;
      case 2:
        showval = "shipped";
        break;
      case 3:
        showval = "delivered";
        break;
      default:
        showval = "";
    }
    return showval;
  };

  console.log(showStatus(), "status");
  console.log("cartBundleId", cartBundleId);

  useEffect(() => {
    dispatch(
      getShipment({
        cartBundleId: id,
        callback: {
          success: (data) => {
            dispatch(getPackageDetails({ shipmentId: data?.awb }));
          },
        },
      })
    );

    dispatch(getCalculationByCardBundleId({ cartBundleId: id }));
  }, []);

  const updatePackage = () => {
    setStatus("packed");

    dispatch(
      createShipment({
        cartBundleId: id,
        addressId: cartBundleId?.address?.id,
        shipment_height: Number(packageData?.height),
        shipment_width: Number(packageData?.breadth),
        shipment_length: Number(packageData?.length),
        weight: Number(packageData?.weight),
        plastic_packaging: packageData?.type === "0" ? true : false,
        callback: {
          success: () =>
            dispatch(
              updateOrderStatusByCartBundleId({
                id: id,
                status: 1,
                callback: {
                  success: () => {
                    navigate(-1);
                  },
                },
              })
            ),
        },
      })
    );
  };

  const updatePacakgeData = (key, value) => {
    setPackageData((prev) => {
      return { ...prev, [key]: value };
    });
  };

  console.log("packdata", packageData);
  console.log("deliveryCharge", calculation);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>CART BUNDLE : {id}</h1>
        {/* {Status < 1 && (
          <div className={styles.statusSelector}>
            {page === "pending" && (
              <div>
                <label className={styles.statusLabel}>Status : </label>
                {user?.role === "admin" ? (
                  <select
                    value={showStatus(Status)}
                    onChange={(e) => handleChange(e.target.value)}
                    className={styles.statusDropdown}
                  >
                    <option value="">Select status</option>z
                    <option value="placed">Placed</option>
                    <option value="packed">Packed</option>
                    <option value="shipped">Shipped</option>
                    <option value="delivered">Delivered</option>
                    <option value="delivered">Cancel</option>
                  </select>
                ) : (
                  <ToggleSwitch />
                )}
              </div>
            )}
          </div>
        )} */}
      </div>

      <div className={styles.topSection}>
        <div className={styles.leftTop}>
          <CartBundleTile cartBundleData={cartBundleId} />
          <PaymentSummary
            calculation={calculation}
            cartBundleId={cartBundleId}
          />
          <div className={styles.bottomSection}>
            {
              <Tracking
                trackingData={packageDetails}
                cartBundleData={cartBundleId}
                status={cartBundleId?.orders[0]?.status}
                // status={2}
              />
            }
          </div>
        </div>
        <div className={styles.rightTop}>
          <AddressTile
            cartBundleData={cartBundleId}
            status={cartBundleId?.orders[0]?.status}
            // status={2}
            cartBundleId={id}
          />

          {Status === 0 && (
            <PackageDetails
              handleSaveChange={updatePackage}
              handleChange={updatePacakgeData}
              packageData={packageData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    cartBundleId: state?.orders?.cartBundleId,
    user: state.login?.user,
    shipment: state.delhivery?.shipment,
    packageDetails: state.delhivery?.packageDetails,
    calculation: state?.calculation?.calculation,
  };
};
export default connect(mapStateToProps, null)(CartBundleDetails);
